// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1300px) {}

@media (max-width: 1120px) {}

@media (max-width: 992px) {
  .long_section {
    margin-left: 30px;
    margin-right: 30px;
  }

  .hero_area {
    min-height: auto;
  }

  .quote_btn-container a {
    margin-right: 0;
    margin-top: 10px;
  }

  .slider_section {
    padding-top: 45px;
    padding-bottom: 90px;
  }

  .quote_btn-container {
    flex-direction: column;
    align-items: center;
  }


}

@media (max-width: 768px) {


  .slider_section {
    padding-top: 45px;
    padding-bottom: 75px;
  }

  .slider_section .detail_box {
    text-align: center;
    padding-left: 0;
  }

  .slider_section .img-box {
    margin-top: 45px;
  }

  .about_section .img-box {
    margin-bottom: 45px;

  }

  .contact_section .form_container {
    margin-bottom: 45px;
  }

  .client_section .box {
    flex-direction: column;
    text-align: center;
    margin: 45px 15px;
  }

  .client_section .box .detail-box {
    align-items: center;
  }

  .client_section .box .img-box {
    margin-right: 0;
    margin-bottom: 25px;
  }

  .info_section .contact_nav {
    flex-direction: column;
    align-items: center;
    padding-bottom: 0;
  }

  .info_section .contact_nav a {
    margin-bottom: 15px;
  }

  .info_section .row>div {
    text-align: center;
  }

  .info_section .info_post .post_box {
    justify-content: center;
  }

  .info_section .info_links .info_links_menu a {
    flex-basis: 100%;
  }

  .info_form {
    margin-top: 35px;
  }

  .info_form form {
    display: flex;
    flex-direction: column;
    align-items: center;

  }

  .info_form .social_box {
    justify-content: center;
  }

  .info_form .social_box a {
    margin: 0 5px;
  }

}

@media (max-width: 576px) {
  .long_section {
    margin-left: 25px;
    margin-right: 25px;
  }


  .info_section .info_links .info_links_menu {
    margin-bottom: 35px;
  }

}

@media (max-width: 480px) {}

@media (max-width: 420px) {
  .long_section {
    margin-left: 15px;
    margin-right: 15px;
  }

  .slider_section .detail-box .btn-box {
    flex-direction: column;
  }

  .slider_section .detail-box .btn-box a {
    width: 100%;
  }

  .furniture_section .box .img-box {
    height: auto;
  }
}

@media (max-width: 376px) {
  .slider_section .detail-box h1 {
    font-size: 2rem;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1170px;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/responsive.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B,4BAA4B;;AAE5B;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;;AAGF;;AAEA;;;EAGE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;;EAErB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;EAErB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;AAEF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;;EAGA;IACE,mBAAmB;EACrB;;AAEF;;AAEA,2BAA2B;;AAE3B;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@media (max-width: 1300px) {}\r\n\r\n@media (max-width: 1120px) {}\r\n\r\n@media (max-width: 992px) {\r\n  .long_section {\r\n    margin-left: 30px;\r\n    margin-right: 30px;\r\n  }\r\n\r\n  .hero_area {\r\n    min-height: auto;\r\n  }\r\n\r\n  .quote_btn-container a {\r\n    margin-right: 0;\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .slider_section {\r\n    padding-top: 45px;\r\n    padding-bottom: 90px;\r\n  }\r\n\r\n  .quote_btn-container {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\r\n\r\n  .slider_section {\r\n    padding-top: 45px;\r\n    padding-bottom: 75px;\r\n  }\r\n\r\n  .slider_section .detail_box {\r\n    text-align: center;\r\n    padding-left: 0;\r\n  }\r\n\r\n  .slider_section .img-box {\r\n    margin-top: 45px;\r\n  }\r\n\r\n  .about_section .img-box {\r\n    margin-bottom: 45px;\r\n\r\n  }\r\n\r\n  .contact_section .form_container {\r\n    margin-bottom: 45px;\r\n  }\r\n\r\n  .client_section .box {\r\n    flex-direction: column;\r\n    text-align: center;\r\n    margin: 45px 15px;\r\n  }\r\n\r\n  .client_section .box .detail-box {\r\n    align-items: center;\r\n  }\r\n\r\n  .client_section .box .img-box {\r\n    margin-right: 0;\r\n    margin-bottom: 25px;\r\n  }\r\n\r\n  .info_section .contact_nav {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  .info_section .contact_nav a {\r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .info_section .row>div {\r\n    text-align: center;\r\n  }\r\n\r\n  .info_section .info_post .post_box {\r\n    justify-content: center;\r\n  }\r\n\r\n  .info_section .info_links .info_links_menu a {\r\n    flex-basis: 100%;\r\n  }\r\n\r\n  .info_form {\r\n    margin-top: 35px;\r\n  }\r\n\r\n  .info_form form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n\r\n  }\r\n\r\n  .info_form .social_box {\r\n    justify-content: center;\r\n  }\r\n\r\n  .info_form .social_box a {\r\n    margin: 0 5px;\r\n  }\r\n\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .long_section {\r\n    margin-left: 25px;\r\n    margin-right: 25px;\r\n  }\r\n\r\n\r\n  .info_section .info_links .info_links_menu {\r\n    margin-bottom: 35px;\r\n  }\r\n\r\n}\r\n\r\n@media (max-width: 480px) {}\r\n\r\n@media (max-width: 420px) {\r\n  .long_section {\r\n    margin-left: 15px;\r\n    margin-right: 15px;\r\n  }\r\n\r\n  .slider_section .detail-box .btn-box {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .slider_section .detail-box .btn-box a {\r\n    width: 100%;\r\n  }\r\n\r\n  .furniture_section .box .img-box {\r\n    height: auto;\r\n  }\r\n}\r\n\r\n@media (max-width: 376px) {\r\n  .slider_section .detail-box h1 {\r\n    font-size: 2rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .container {\r\n    max-width: 1170px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
